import { render, staticRenderFns } from "./PaymentInitiation.vue?vue&type=template&id=344ad3f7"
import script from "./PaymentInitiation.vue?vue&type=script&lang=js"
export * from "./PaymentInitiation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports